import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { BusierHoursReportCreate } from '../models/busier-hours-report.model';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ReportBusierHoursService {
  private apiService = inject(ApiService);
  private readonly apiUrl: string = environment.apiUrl;
  private http = inject(HttpClient);
  private pipe = new DatePipe('en-US');

  getReportBusierHours(formData: BusierHoursReportCreate): Observable<any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }

    const create = this.createTexteQuery(formData);

    console.log('Create', create);
    return this.apiService.getAll(`report/getBusiestReservedFloors?${create}`);
  }

  getReportBusierHoursPdf(
    formData: BusierHoursReportCreate
  ): Observable<Blob | any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    console.log('Create', create);
    return this.http.get(
      `${this.apiUrl}report/getBusiestReservedFloorsPDF?${create}`,
      { responseType: 'blob' as 'json' }
    );
  }

  getReportBusierHoursCsv(
    formData: BusierHoursReportCreate
  ): Observable<Blob | any> {
    if (formData.startDate) {
      formData.startDate =
        this.pipe.transform(formData.startDate, 'dd-MM-yyyy')?.toString() +
        ' 00:00:00';
    }

    if (formData.endDate) {
      formData.endDate =
        this.pipe.transform(formData.endDate, 'dd-MM-yyyy')?.toString() +
        ' 23:59:00';
    }
    const create = this.createTexteQuery(formData);
    return this.http.get(
      `${this.apiUrl}report/getBusiestReservedFloorsCSV?${create}`,
      { responseType: 'blob' as 'json' }
    );
  }

  private createTexteQuery(formData: BusierHoursReportCreate) {
    let text = '';
    if (formData.startDate) {
      text += 'startDate=' + formData.startDate;
    }
    if (formData.endDate) {
      if (text) {
        text += '&endDate=' + formData.endDate;
      } else {
        text += 'endDate=' + formData.endDate;
      }
    }

    if (formData.workplaceTypeId) {
      if (text) {
        text += '&workplaceTypeId=' + formData.workplaceTypeId;
      } else {
        text += 'workplaceTypeId=' + formData.workplaceTypeId;
      }
    }

    if (formData.buildingId) {
      if (text) {
        text += '&buildingId=' + formData.buildingId;
      } else {
        text += 'buildingId=' + formData.buildingId;
      }
    }

    if (formData.floorId) {
      if (text) {
        text += '&floorId=' + formData.floorId;
      } else {
        text += 'floorId=' + formData.floorId;
      }
    }

    if (formData.workplaceId) {
      if (text) {
        text += '&workplaceId=' + formData.workplaceId;
      } else {
        text += 'workplaceId=' + formData.workplaceId;
      }
    }
    if (formData.worker) {
      if (text) {
        text += '&worker=' + formData.worker;
      } else {
        text += 'worker=' + formData.worker;
      }
    }

    if (formData.businessId) {
      if (text) {
        text += '&businessId=' + formData.businessId;
      } else {
        text += 'businessId=' + formData.businessId;
      }
    }

    if (formData.reservationStatusId) {
      if (text) {
        text += '&reservationStatusId=' + formData.reservationStatusId;
      } else {
        text += 'reservationStatusId=' + formData.reservationStatusId;
      }
    }
    return text;
  }
}
